import React, { useCallback, useEffect, useRef, useState } from "react";
import { MessageSquare } from "lucide-react";
import { api } from "../../lib/api";

const ago = (s) => (s ? new Date(s).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "");

// Polls unread vendor text replies the rep can see.
export function useUnreadTexts() {
  const [d, setD] = useState({ rows: [], total: 0 });
  const reload = useCallback(() => api.get("/sales/sms-unread").then((r) => setD(r.data)).catch(() => {}), []);
  useEffect(() => { reload(); const t = setInterval(reload, 30000); return () => clearInterval(t); }, [reload]);
  const map = Object.fromEntries(d.rows.map((r) => [r.prospect_id, r.count]));
  return { ...d, map, reload };
}

export function RepliesButton({ un, onOpen }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);
  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen(!open)} className={`relative inline-flex items-center gap-1.5 rounded-full border px-3 py-2 text-xs font-semibold transition-colors ${un.total ? "border-red-300 bg-red-50 text-red-700" : "border-[var(--line)] bg-white text-black/70 hover:border-[var(--gold)]"}`} data-testid="vi-replies-btn">
        <MessageSquare className="w-4 h-4" />Text replies
        {un.total > 0 && <span className="min-w-5 h-5 px-1 rounded-full bg-red-600 text-white text-[11px] flex items-center justify-center" data-testid="vi-replies-count">{un.total}</span>}
      </button>
      {open && <div className="absolute left-0 sm:left-auto sm:right-0 top-full mt-2 w-[min(20rem,calc(100vw-2rem))] max-h-96 overflow-y-auto bg-white border border-[var(--line)] rounded-2xl shadow-xl z-40 p-2" data-testid="vi-replies-menu">
        {!un.rows.length && <p className="text-xs text-black/60 text-center py-6" data-testid="vi-replies-empty">No new text replies.</p>}
        {un.rows.map((r) => (
          <button key={r.prospect_id} onClick={() => { setOpen(false); onOpen(r.prospect_id); }} className="w-full text-left rounded-xl p-2.5 hover:bg-black/5 transition-colors" data-testid={`vi-reply-${r.prospect_id}`}>
            <p className="flex items-center gap-2 text-sm"><span className="font-semibold truncate flex-1">{r.business_name || r.from}</span><span className="text-[11px] rounded-full bg-red-600 text-white px-1.5">{r.count}</span></p>
            <p className="text-xs text-black/70 line-clamp-2">{r.last_text}</p>
            <p className="text-[11px] text-black/50 mt-0.5">{ago(r.at)}</p>
          </button>))}
      </div>}
    </div>
  );
}
